import React from 'react';
import PictureTypes from './types/picture';
const defaultProps = {
  alt: ''
};

/**
 * Picture component
 */
const Picture = ({
  pictureClassname,
  imgClassname,
  xxl,
  xl,
  lg,
  md,
  sm,
  xs,
  alt
}) => {
  return /*#__PURE__*/React.createElement("picture", {
    className: pictureClassname ? pictureClassname : ''
  }, (xxl === null || xxl === void 0 ? void 0 : xxl.src) && /*#__PURE__*/React.createElement("source", {
    srcSet: xxl.src,
    width: xxl.width,
    height: xxl.height,
    media: "(min-width: 3840px)"
  }), (xl === null || xl === void 0 ? void 0 : xl.src) && /*#__PURE__*/React.createElement("source", {
    srcSet: xl.src,
    width: xl.width,
    height: xl.height,
    media: "(min-width: 1920px)"
  }), (lg === null || lg === void 0 ? void 0 : lg.src) && /*#__PURE__*/React.createElement("source", {
    srcSet: lg.src,
    width: lg.width,
    height: lg.height,
    media: "(min-width: 1440px)"
  }), (md === null || md === void 0 ? void 0 : md.src) && /*#__PURE__*/React.createElement("source", {
    srcSet: md.src,
    width: md.width,
    height: md.height,
    media: "(min-width: 1024px)"
  }), (sm === null || sm === void 0 ? void 0 : sm.src) && /*#__PURE__*/React.createElement("source", {
    srcSet: sm.src,
    width: sm.width,
    height: sm.height,
    media: "(min-width: 768px)"
  }), /*#__PURE__*/React.createElement("img", Object.assign({}, xs, {
    className: imgClassname || '',
    alt: alt,
    loading: "lazy"
  })));
};
Picture.defaultProps = defaultProps;
export default Picture;